import React from 'react'
import { AppActivityEmptyStateUnlicensed } from '../../../components/route-coverage-grid/empty-state'
import { createNgReactBridgeDirective } from '../../react-bridge'

const AppActivityEmptyStateBridge = () => {
  return <AppActivityEmptyStateUnlicensed />
}

export const reactAppActivityEmptyState = createNgReactBridgeDirective(
  'reactAppActivityEmptyState',
  [],
  AppActivityEmptyStateBridge,
  []
)
